export type AccountView = ReturnType<typeof auctionView>;

export default function auctionView(
  account: string | null,
  isOrderBook: boolean,
) {
  return {
    selectedOption: account,
    isValid: isOrderBook || (account != null && account !== ''),
  };
}
